// CourseContent.jsx

import ContentDataTable from "../../components/ContentDataTable/ContentDataTable";

const CourseContent = () => {
  return (
    <ContentDataTable
      title="Course Contents"
      apiEndpoint="/pinging-course-content"
      defaultValue="all"
    />
  );
};

export default CourseContent;
